import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';

const GeneralSettings = ({
    registrationIdsSelected
}) => {
    const [idItem, setIdItem] = useState(null);
    const [externalItemIdentifier, setExternalItemIdentifier] = useState(null);
    const [lunchTime, setLunchTime] = useState(null);
    const [percentageDay, setPercentageDay] = useState('S');
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [existRecord, setExistRecord] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idItem, setter: setIdItem },
        { name: "externalItemIdentifier", value: externalItemIdentifier, setter: setExternalItemIdentifier },
        { name: "lunchTime", value: lunchTime, setter: setLunchTime },
        { name: "percentageDay", value: percentageDay, setter: setPercentageDay },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        reloadListItem()
    }, [registrationIdsSelected])

    useEffect(() => {
        if (updating || inserting) {
            return;
        }

        setIfExistRecord()
    }, [registrationIdsSelected, inserting, updating])

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    const reloadListItem = async () => {
        const item = await ExecuteAxios.api('get', `/general-settings/get-general-settings-detail/`)
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }
    };

    const getItemPanelListOrDetail = () => {
        return (
            <AutomaticallyListedAttributes
                list={attributesDetailItemPanel}
                attributeList={attributeList}
                readOnlyAttributes={readOnlyAttributes}
            />
        )
    }

    async function postItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('post', `/general-settings/`, {
                timeLunch: lunchTime,
                percentageDay: percentageDay,
                externalItemIdentifier: externalItemIdentifier
            });

            if (response) {
                await reloadListItem()
            }

            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('put', `/general-settings/`, {
                id: idItem,
                timeLunch: lunchTime,
                percentageDay: percentageDay,
                externalItemIdentifier: externalItemIdentifier
            });

            if (response) {
                await reloadListItem()
            }

            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    async function setIfExistRecord() {
        setExistRecord(await ExecuteAxios.api('get', `/general-settings/check-if-exists-record-in-general-settings/`))
    };

    return (
        <LoadingIndicator loaded={!loadingItemPanel}>
            <Panel
                style={itemPanelStyle}
                titlePage={'Cadastros Gerais'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={existRecord}
                canEdit={true}
                putFunction={putItem}
                enableNewRecord={!existRecord}
                canNewRecord={!existRecord}
                postFunction={postItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={[]}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailItemPanel}
                attributeList={attributeList}
            >
                {getItemPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}
export default GeneralSettings;